/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkforceRedirectEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const workforceRedirectEntryPoint: EntryPoint<
	WorkforceRedirectEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<WorkforceRedirectEntryPointComponent>(
		/* webpackChunkName: "async-project-settings-service-desk-workforce-redirect" */ './WorkforceRedirect.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => ({}),
});
